import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck, faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './FeedbackCompass.css';
import feedbackcompassimage from '../../assets/pageimages/FeedbackCompass.webp';

function FeedbackCompassHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>FeedbackCompass</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/feedbackcompass-itemlist" className="top-button-link"><FontAwesomeIcon icon={faList} className="feedbackcompass-bottomlink-style" />Items List</Link></div>
              <div className="bottom-buttons-box"><Link to="/feedbackcompass-createcode" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="feedbackcompass-bottomlink-style" />Generate Code</Link></div>
              <div className="bottom-buttons-box"><Link to="/feedbackcompass-fakereport" className="top-button-link"><FontAwesomeIcon icon={faListUl} className="feedbackcompass-bottomlink-style" />Fake Report</Link></div>
              <div className="bottom-buttons-box"><Link to="/feedbackcompass-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="feedbackcompass-bottomlink-style" />FeedbackCompass Scan</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="feedbackcompass-id" src={feedbackcompassimage} alt="FeedbackCompass Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default FeedbackCompassHome;
